import { Component } from "@angular/core";
import { BaseComponent } from "../shared/base/base.component";
import { ActivatedRoute } from "@angular/router";
import { LoggedUserService } from "../services/common/logged-user.service";

@Component({
  selector: "administration-component",
  templateUrl: "./administration.component.html",
})
export class AdministrationComponent extends BaseComponent {
  title = "Administration";
  links: any[] = [];

  constructor(
    loggedUserService: LoggedUserService,
    route: ActivatedRoute
  ) {
    super(loggedUserService, route);
    
  }

  ngOnInit(): void { }
}
